<div class="btn btn-white js-token-show" id="{{token}}"><i class="fa fa-eye"></i></div>
<div class="btn btn-white js-token-copy" id="{{token}}"><i class="fa fa-clipboard"></i></div>
<div class="btn btn-white js-token-try" id="{{token}}"><i class="fa fa-connectdevelop"></i></div>
